import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const { search } = useLocation();
  return { query: new URLSearchParams(search), search };
};
